"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALUE_TYPES = void 0;
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/rules-of-hooks */
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
const constants_1 = require("../../utilities/constants");
const format_1 = require("../../utilities/format");
const measurements_1 = require("../../utilities/measurements");
const constants_2 = require("./constants");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
exports.VALUE_TYPES = (0, lodash_1.default)(format_1.VALUE_FORMATS).omit(['default']).keys().value();
const BulletChart = _ref => {
  let {
    colorScale = constants_2.DEFAULT_COLOR_SCALE,
    bulletsOpacity = constants_2.DEFAULT_BULLET_OPACITY,
    max,
    min,
    currentValue,
    fontSize = constants_1.DEFAULT_FONT_SIZE,
    fontColor = constants_2.DEFAULT_TEXT_COLOR,
    type = constants_2.DEFAULT_LABEL_FORMAT,
    indicatorOptions = constants_2.DEFAULT_INDICATOR_OPTIONS
  } = _ref;
  if (!colorScale || colorScale.length < 1 || min === undefined || max === undefined || !format_1.VALUE_FORMATS[type]) {
    return null;
  }
  const labelFormat = format_1.VALUE_FORMATS[type];
  /* Initialize options */
  const optsIndicator = lodash_1.default.defaultsDeep({}, indicatorOptions, {
    radius: constants_2.DEFAULT_INDICATOR_RADIUS
  }, constants_2.DEFAULT_INDICATOR_OPTIONS);
  optsIndicator.strokeColor = (0, colors_1.parseColor)(optsIndicator.strokeColor, constants_2.DEFAULT_INDICATOR_STROKE_COLOR);
  const weightOfSingleBullet = (max - min) / colorScale.length;
  let indicatorColorIndex = Math.floor((currentValue - min) / weightOfSingleBullet);
  const indicatorLeftMarginPercent = ((currentValue - min) / (max - min) * 100).toFixed(2);
  let labelStyleCurrentValue = {
    left: `calc(${indicatorLeftMarginPercent}% - ${constants_2.DEFAULT_INDICATOR_RADIUS}px)`
  };
  // handling special cases
  if (currentValue <= min) {
    indicatorColorIndex = 0;
  } else if (max <= currentValue) {
    indicatorColorIndex = colorScale.length - 1;
  }
  const indicatorColor = colorScale[indicatorColorIndex];
  const formattedMin = labelFormat(min);
  const formattedMax = labelFormat(max);
  const formattedCurrentValue = labelFormat(currentValue);
  let indicatorIsLabel = null; // can be left/right if indicator label concides with label
  const labelStyleLeft = {
    right: `calc(100% - ${(0, measurements_1.textDimensions)({
      text: formattedMin,
      fontSize
    }).width}px)`
  };
  const labelStyleRight = {
    left: `calc(100% - ${(0, measurements_1.textDimensions)({
      text: formattedMax,
      fontSize
    }).width}px)`
  };
  if (indicatorColorIndex === 0) {
    if (formattedMin === formattedCurrentValue) {
      indicatorIsLabel = 'left';
    } else {
      labelStyleCurrentValue = {
        right: `calc(100% - ${(0, measurements_1.textDimensions)({
          text: formattedMin,
          fontSize
        }).width}px)`,
        transform: 'translateX(100%)',
        paddingLeft: '6px'
      };
    }
  } else if (indicatorColorIndex === colorScale.length - 1) {
    if (formattedMax === formattedCurrentValue) {
      indicatorIsLabel = 'right';
    } else {
      labelStyleCurrentValue = {
        left: `calc(100% - ${(0, measurements_1.textDimensions)({
          text: formattedMax,
          fontSize
        }).width}px)`,
        transform: 'translateX(-100%)',
        paddingRight: '6px'
      };
    }
  }
  return react_1.default.createElement("div", {
    className: styles_module_css_1.default['bullets-chart']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['value-label-container'],
    style: {
      fontSize: `${fontSize}px`,
      color: (0, colors_1.parseColor)(fontColor, constants_2.DEFAULT_TEXT_COLOR),
      height: (0, measurements_1.textDimensions)({
        text: formattedMin,
        fontSize
      }).height
    }
  }, react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['value-label']} ${styles_module_css_1.default['left-value-label']} ${indicatorIsLabel === 'left' ? styles_module_css_1.default['focused-label'] : ''}`,
    style: labelStyleLeft
  }, labelFormat(min)), !indicatorIsLabel && react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['value-label']} ${styles_module_css_1.default['focused-label']}`,
    style: labelStyleCurrentValue
  }, labelFormat(currentValue)), react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['value-label']} ${styles_module_css_1.default['right-value-label']} ${indicatorIsLabel === 'right' ? styles_module_css_1.default['focused-label'] : ''}`,
    style: labelStyleRight
  }, labelFormat(max))), react_1.default.createElement("div", {
    className: styles_module_css_1.default['bullets-items-container']
  }, colorScale.map((color, i) => react_1.default.createElement("div", {
    key: i,
    className: styles_module_css_1.default['bullet-item'],
    style: {
      opacity: bulletsOpacity,
      backgroundColor: color,
      height: constants_2.DEFAULT_BULLET_HEIGHT
    }
  })), react_1.default.createElement("div", {
    className: styles_module_css_1.default['circle-indicator'],
    style: {
      width: `${optsIndicator.radius * 2}px`,
      height: `${optsIndicator.radius * 2}px`,
      backgroundColor: `${indicatorColor}`,
      left: `calc(${indicatorLeftMarginPercent}% - 7px)`,
      borderWidth: `${optsIndicator.strokeWidth}px`,
      borderColor: `${optsIndicator.strokeColor}`
    }
  })));
};
BulletChart.propTypes = {
  /**
   * Colors for each section of the bullets.
   * @param colorScale {[string]} array of colors for  the bullet
   */
  colorScale: (0, prop_types_1.arrayOf)(prop_types_1.string),
  /**
   * @param bulletsOpacity {number} the opacity of the bullets
   */
  bulletsOpacity: prop_types_1.number,
  /**
   * @param currentValue {number} the current value.
   */
  currentValue: prop_types_1.number.isRequired,
  /**
   * min value in scale
   * @param min {number} minimum number of the scale.
   */
  min: prop_types_1.number.isRequired,
  /**
   * max value n scale
   * @param mam {number} maximum number of the scale.
   *  */
  max: prop_types_1.number.isRequired,
  /**
   * Font size for for the labels
   * @param fontSize {number} font size of the labels
   */
  fontSize: prop_types_1.number,
  /**
   * Font color for bullets labels.
   * @param fontColor {string} color of the labels
   */
  fontColor: prop_types_1.string,
  /**
   * type of formatting for bullets labels.
   * @param type {string} value type - 'items','linear','unformatted','percent','dollars','years',
   * 	'yearly','months','monthly','quarters','quarterly','weeks','weekly','days','daily'
   */
  type: (0, prop_types_1.oneOf)(exports.VALUE_TYPES),
  /**
   *  Properties for the marker
   * @param strokeWidth {number} stroke width, default to 1
   * @param strokeColor {string} stroke color of the radius, default wo white
   * @param radius {number} radius of the the indicator
   * @param onMouseOver {func} onMouseOver
   * @param onMouseOut {func} onMouseOut
   * @param onClick {func} onClick
   * */
  indicatorOptions: (0, prop_types_1.shape)({
    strokeWidth: prop_types_1.number,
    strokeColor: prop_types_1.string,
    onMouseOver: prop_types_1.func,
    onClick: prop_types_1.func,
    onMouseOut: prop_types_1.func
  })
};
exports.default = BulletChart;